module.exports = __webpack_public_path__ + "Icon_Items.ae71f22c290a71d23830.png";